import React, {PropTypes} from 'react';
import {connect} from 'react-redux';


// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class EducationGem extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {}
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Education';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className={'EducationGem EducationPage'}>
      <div className='eduHeader'>Colored Stones &amp; Pearls</div>
      <div className='eduBody'>
        <div className='gemSection'>
          <div className='gemImg'>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/desktop/gemtop.jpg' />
          </div>
          <div className='gemText'>
            <div className='gemTitle'>GEMSTONES</div>
            <div className='gemP'>Though Diamonds Direct is synonymous with diamonds, we are also proud to offer an extensive collection of fine, precious, and semi-precious gemstones. From loose stones to completed jewelry pieces- we have a collection of colored stones that will exceed your expectations. Our skilled diamond experts are extremely knowledgeable about colored gemstones and will help you choose the perfect colored gemstone jewelry to suit both your budget and your special someone.</div>
            <div className='gemP'>The most commonly requested precious gemstones are sapphire, ruby, and emerald. When determining the value and quality of a precious gemstone, color is the primary characteristic to take into consideration. Gemologists divide gemstone color into three categories: hue, tone and intensity.</div>
            <div className='gemP' style={{textAlign: 'center'}}>
              <span className='gemLink' onClick={() => this.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet')}>Shop Gemstone Jewelry &gt;</span>
            </div>
          </div>
        </div>
        <div className='birthSection'>
          <div className='birthBox'>
            <div className='boxWrapper'>
              <div className={'gemTitle titleSmall'}>BIRTHSTONES</div>
              <div className='boxBr'>
                <img src='https://ddw2.diamondsdirect.com/img/finance/icons/iconline.svg' />
              </div>
              <div className='boxP'>Birthstones are gemstones that correspond with a birth month. Each birthstone has a unique meaning, making birthstone jewelry a wonderful birthday gift or push present.</div>
              <div className='boxGemWrapper'>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/january.jpg' />
                  </div>
                  <div className='boxGemMonth'>JANUARY</div>
                  <div className='boxGemLabel'>Garnet</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/february.jpg' />
                  </div>
                  <div className='boxGemMonth'>FEBRUARY</div>
                  <div className='boxGemLabel'>Amethyst</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/march.jpg' />
                  </div>
                  <div className='boxGemMonth'>MARCH</div>
                  <div className='boxGemLabel'>Aquamarine</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/april.jpg' />
                  </div>
                  <div className='boxGemMonth'>APRIL</div>
                  <div className='boxGemLabel'>Diamond</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/may.jpg' />
                  </div>
                  <div className='boxGemMonth'>MAY</div>
                  <div className='boxGemLabel'>Emerald</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/june.jpg' />
                  </div>
                  <div className='boxGemMonth'>JUNE</div>
                  <div className='boxGemLabel'>Pearl / Alexandrite</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/july.jpg' />
                  </div>
                  <div className='boxGemMonth'>JULY</div>
                  <div className='boxGemLabel'>Ruby</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/august.jpg' />
                  </div>
                  <div className='boxGemMonth'>AUGUST</div>
                  <div className='boxGemLabel'>Peridot</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/september.jpg' />
                  </div>
                  <div className='boxGemMonth'>SEPTEMBER</div>
                  <div className='boxGemLabel'>Sapphire</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/october.jpg' />
                  </div>
                  <div className='boxGemMonth'>OCTOBER</div>
                  <div className='boxGemLabel'>Opal / Pink Tourmaline</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/november.jpg' />
                  </div>
                  <div className='boxGemMonth'>NOVEMBER</div>
                  <div className='boxGemLabel'>Citrine</div>
                </div>
                <div className='boxGemItem'>
                  <div className='boxGemImg'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/gem/birthstones/december.jpg' />
                  </div>
                  <div className='boxGemMonth'>DECEMBER</div>
                  <div className='boxGemLabel'>Topaz</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'pearlSection mobileOnly'}>
          <div className='pearlMobTopImg'>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/mobile/pearl-neck_m.jpg' />
          </div>
          <div className={'gemTitle pearlMobileTitle'}>PEARLS</div>
          <div className={'gemP pearlGemP'}>A pearl is formed when a foreign object, such as a grain of sand, accidentally finds its way into an oyster or mollusk. In an effort to heal, the mollusk secretes layers of a crystalline material called nacre upon the object lodged inside. After a period of time, the layers of nacre appear smooth, hard and luminescent- and a pearl is born!</div>
          <div className='gemP pearlGemP'>Natural pearls, formed by the process identified above are very rare and very expensive because this process is based solely on chance. To accommodate the growing retail market, most pearls sold today are cultured pearls. Cultured pearls are made with the help of humans inserting an object into an oyster. The oyster is placed in to warm water while slightly open to help the pearl form over a period of several years.</div>
          <div className='gemP pearlGemP' style={{textAlign: 'center', margin: '20px 0'}}>
            <span className='gemLink' onClick={() => this.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet&gemstone=pearl')}>Shop Pearl Jewelry &gt;</span>
          </div>
          <div className={'gemInfo gemInfo1'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/mobile/luster_m.png' />
          </div>
          <div className={'gemInfo gemInfo2'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/mobile/shape_m.png' />
          </div>
          <div className='gemMobMidImage'>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/mobile/pearlchar_m.png' />
          </div>
          <div className={'gemInfo gemInfo3'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/mobile/size_m.png' />
          </div>
          <div className={'gemInfo gemInfo4'}>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/mobile/color_m.png' />
          </div>
          <div className='gemMobLastImage'>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/mobile/pearl_neck2_m.png' />
          </div>
          <div className='gemOriginSection'>
            <div className='gemTitle'>PEARL ORIGINS</div>
            <div className={'gemP'}>In addition to quality, pearls are identified and labeled based on their origin:</div>
            <div className='pearlLocation'>
              <div className='plName'>AKOYA</div>
              <div className='plBody'>Cultured in China and Japan. Most known for their luster, akoya pearls are considered the classic pearl. They are generally white or cream colored with overtone colors of rose, silver or cream. Sizes range from 2 to 11 mm.</div>
            </div>
            <div className='pearlLocation'>
              <div className='plName'>CHINESE FRESHWATER</div>
              <div className='plBody'>Cultivated in mussels in lakes and rivers, these pearls grow in an awesome variety of colors and shapes. These pearls are very affordable.</div>
            </div>
            <div className='pearlLocation'>
              <div className='plName'>SOUTH SEA PEARLS</div>
              <div className='plBody'>Cultured from the silver or white-lip oyster, primarily in the northern waters of Australia, Indonesia and the Philippines, these pearls grow to exceptional size; 10 to 20 mm. These are highly prized and precious.</div>
            </div>
            <div className='pearlLocation'>
              <div className='plName'>TAHITIAN PEARLS</div>
              <div className='plBody'>Cultured from the black-lip oyster in the waters of the South Pacific, these pearls come in larger sizes, from 10 to 20 mm, and a varia- tion of colors including black, gray, burgundy, peacock and gold. Mystical and dark, the popu- larity of Tahitian pearls has surged in recent years, making strands of these pearls one of the most sought-after pieces of jewelry.</div>
            </div>
          </div>
        </div>
        <div className={'pearlSection desktopOnly'}>
          <div className='gemTitle'>PEARLS</div>
          <div className={'gemP halfWidth'}>A pearl is formed when a foreign object, such as a grain of sand, accidentally finds its way into an oyster or mollusk. In an effort to heal, the mollusk secrets layers of a crystalline material called nacre upon the object lodged inside. After a period of time, the layers of nacre appear smooth, hard and luminescent- and a pearl is born!</div>
          <div className='gemP'>Natural pearls, formed by the process identified above are very rare and very expensive because this process is based solely on chance. To accommodate the growing retail market, most pearls sold today are cultured pearls. Cultured pearls are made with the help of humans inserting an object into an oyster. The oyster is placed in warm water while slightly open to help the pearl form over a period of several years. The process of creating cultured pearls began in japan in the late 19th century and has aided the industry in creating pearls of varying shape, color, size and quality in mass quantities.</div>
        </div>
        <div className={'pearlCharSection desktopOnly'}>
          <div className='pearlTopArea'>
            <div className='pearlTextArea'>
              <div className={'gemTitle titleSmall'}>PEARL CHARACTERISTICS</div>
              <div className='pearlP'>Pearl quality can vary dramatically, and just like other gemstones, only a tiny percentage are considered beautiful enough for use in jewelry. Characteristics that con- tribute to the value of a pearl are luster and nacre thickness, surface, shape, color and size.</div>
              <div className='pearlP' style={{textAlign: 'center', margin: '20px 0'}}>
                <span className='gemLink' onClick={() => this.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet&gemstone=pearl')}>Shop Pearl Jewelry &gt;</span>
              </div>
            </div>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/desktop/pearlchar.png' />
          </div>
          <div className='pearlBottomArea'>
            <img src='https://ddw2.diamondsdirect.com/img/education/gem/desktop/originsb.jpg' />
          </div>
        </div>
      </div>
		</div>;
	}
}
export default EducationGem;

function mapStateToProps(state) {
  return {

  };
}

export const EducationGemContainer = connect(
  mapStateToProps,
  allActionCreators
)(EducationGem);


// WEBPACK FOOTER //
// ./src/components/views/education/EducationGem.jsx